export const getPassioDomain = () => {
  if(typeof window === 'undefined') {
    return ''
  }
  const full = window.location.host;
  const parts = full.split('.');
  const domain = parts[1];
  const type = parts[2];
  return `.${domain}.${type}`
}
